
const editDayType = (itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
  const { dayTypeId, resourceDayType, dayTypeComment, myDayTypeComment } = itemDetails;
  const { resourceDayTypeId } = resourceDayType;
  const tempRdtId = `${resourceDayTypeId}-optimistic`;
  const title =  dayTypesAll.find((elem) => dayTypeId == elem.dayTypeId) ? dayTypesAll.find((elem) => dayTypeId == elem.dayTypeId).dayTypeName : dayTypesAllowTour.find((elem) => dayTypeId == elem.id) ? dayTypesAllowTour.find((elem) => dayTypeId == elem.id).name : null
   // address cloud server utc time offset (4 hours)
  const origResource = optimisticLiveSchedule.find((elem) => resourceId === elem.rId);
  const resource = JSON.parse(JSON.stringify(origResource));
  // resource.dayTypes[resourceDayTypeId].rdtId = (resource.dayTypes[resourceDayTypeId].rdtId).toString + '-optimistic';
  if (resource.dayTypes[resourceDayTypeId]) {
    // create and populate new dayType obj
    resource.dayTypes[tempRdtId] = {};
    resource.dayTypes[tempRdtId].rdtId = tempRdtId;
    resource.dayTypes[tempRdtId].dayTypeId = dayTypeId
    resource.dayTypes[tempRdtId].title = title;
    resource.dayTypes[tempRdtId].dayTypeComment = dayTypeComment;
    resource.dayTypes[tempRdtId].myDayTypeComment = myDayTypeComment;
      if (resource.dayTypes[resourceDayTypeId].dayOff) {
        const { startTime, endTime, } = resource.dayTypes[resourceDayTypeId].dayOff;
        // create and populate new dayOff obj
        resource.dayTypes[tempRdtId].dayOff = {};
        resource.dayTypes[tempRdtId].dayOff.dorId = dayTypeId;  // not sure this is accurate
        resource.dayTypes[tempRdtId].dayOff.title = title;
        resource.dayTypes[tempRdtId].dayOff.startTime = startTime;
        resource.dayTypes[tempRdtId].dayOff.endTime = endTime;
        resource.dayTypes[tempRdtId].dayOff.dayTypeComment = dayTypeComment;
        resource.dayTypes[tempRdtId].dayOff.myDayTypeComment = myDayTypeComment;
      }
      if (resource.dayTypes[resourceDayTypeId].tour) {
        // create and populate new tour obj
        resource.dayTypes[tempRdtId].tour = resource.dayTypes[resourceDayTypeId].tour;
      }

    // delete old dayType
    delete resource.dayTypes[resourceDayTypeId];
  }
  return resource;
}

export default editDayType;
